<template>
  <div class="top">
    <van-icon
      @click="goBack()"
      class="back"
      name="arrow-left"
      color="#aaaaaa"
    />
    <van-icon
      v-if="token"
      @click="showNav = !showNav"
      class="bars"
      name="bars"
      color="#aaaaaa"
    />
    {{ title }}
    <ul class="nav" v-if="showNav">
      <li class="item"><router-link to="email">消息</router-link></li>
      <li class="item"><router-link to="/">首页</router-link></li>
      <li class="item"><router-link to="person">个人中心</router-link></li>
      <li class="item">
        <router-link :to="{ path: 'goods-game', query: { type: 2 } }"
          >我要买</router-link
        >
      </li>
      <li class="item">
        <router-link :to="{ path: 'goods-want-index', query: { type: 2 } }"
          >我要卖</router-link
        >
      </li>
      <!-- <li class="item">
        <router-link :to="{ path: 'help-detail', query: { name: 'customer' } }"
          >客服</router-link
        >
      </li> -->
    </ul>
  </div>
</template>
<script>
import { getToken } from "@/utils/auth";
import storage from "@/utils/storage";
export default {
  props: ["title"],
  data() {
    return {
      token: getToken(),
      showNav: false,
    };
  },
  methods: {
    goBack() {
      if (storage.get("callbackUrl")) {
        var callbackUrl = storage.get("callbackUrl");
        window.location.href = callbackUrl;
      } else {
        if (this.$route.path != "/login") {
          this.$router.back(-1);
        } else {
          this.$router.push({ path: "/" });
        }
      }
    },
  },
};
</script>

<style scoped>
.top {
  height: 44px;
  line-height: 44px;
  font-size: 16px;
  background: #ebebeb;
  position: relative;
  text-align: center;
}
.top .back {
  position: absolute;
  font-size: 26px;
  left: 10px;
  top: 10px;
}
.top .bars {
  position: absolute;
  font-size: 26px;
  right: 10px;
  top: 10px;
}
.nav {
  z-index: 999;
  position: fixed;
  font-size: 26px;
  right: 10px;
  top: 34px;
  background: #000000;
  opacity: 0.8;
}
.nav .item {
  border-bottom: 1px solid #ffffff;
  height: 28px;
  line-height: 27px;
  font-size: 14px;
  width: 80px;
}
.nav .item a {
  color: #ffffff;
}
</style>